export default __webpack_public_path__ + "static/media/vector_l.21f203f5.png";